import Serializer from 'umg-ember-backend/serializers/application';

export default class MediaEventSerializer extends Serializer {
  attrs = {
    variantChannel: 'vChannelId',
    ownedByChannel: 'ownedByChannelId',
  };
}
